import { GallerySettings } from '@adUtilities/types/carousel'

export const DEFAULT_GALLERY_SETTINGS: GallerySettings = {
  autoPlayIntervalInSeconds: 7,
  effectType: 'slide',
}

export default DEFAULT_GALLERY_SETTINGS
